import { Button, ButtonGroup, ClickAwayListener, Grow, Link, MenuItem, MenuList, Paper, Popper } from "@mui/material";
import ProductCatalogsDataGrid from "components/ProductCatalogs/ProductCatalogsDataGrid";
import { Link as RouterLink } from "react-router-dom";
import { useRef, useState } from "react";
import UploadPricingModal from "components/ProductCatalogs/UploadPricingModal";
import { ArrowDropDown } from "@mui/icons-material";
import useTableExport from "hooks/useTableExport";
import { useFeatureFlag } from "hooks/useFeatureFlag";
import { FullPagePaperLayout } from "pages/Layouts/FullPagePaperLayout";
import { PageActions, PageBreadcrumbs, PageTitle } from "pages/Layouts/components/PageTitleContainer";

export const ProductCatalogIndexPage = () => {
  const [open, setOpen] = useState(false);
  const { isLoading, confirmExportModal, setOpenConfirmModal } = useTableExport({ url: "/product_catalogs_export" });
  const [actionsOpen, setActionOpen] = useState(false);
  const actionButtonGroupAnchorRef = useRef<HTMLDivElement>(null);
  const { enabled: wholesaleEnabled } = useFeatureFlag("product_catalogs_wholesale");
  const handleActionButtonOpenToggle = () => {
    setActionOpen((prevActionOpen) => !prevActionOpen);
  };

  return (
    <>
      {open && <UploadPricingModal open={open} setOpen={setOpen} />}
      {confirmExportModal}
      <FullPagePaperLayout>
        <PageBreadcrumbs links={[{ label: "Resale" }]} />
        <PageTitle>Product Catalog</PageTitle>
        <PageActions>
          <ButtonGroup variant="contained" ref={actionButtonGroupAnchorRef}>
            <Button variant="contained" disableElevation disableRipple disableFocusRipple>
              Actions
            </Button>
            <Button onClick={handleActionButtonOpenToggle}>
              <ArrowDropDown />
            </Button>
          </ButtonGroup>
          <Popper
            sx={{
              zIndex: 1,
            }}
            open={actionsOpen}
            anchorEl={actionButtonGroupAnchorRef.current}
            role={undefined}
            transition
            disablePortal
          >
            {({ TransitionProps }) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin: "bottom",
                }}
              >
                <Paper>
                  <ClickAwayListener onClickAway={() => setActionOpen(false)}>
                    <MenuList id="split-button-menu" autoFocusItem>
                      <MenuItem onClick={() => setOpenConfirmModal(true)} disabled={isLoading}>
                        Export Product Catalog
                      </MenuItem>
                      <MenuItem onClick={() => setOpen(true)}>Upload eBay Prices</MenuItem>
                      {wholesaleEnabled && (
                        <MenuItem>
                          <Link component={RouterLink} underline="none" color="inherit" to="wholesale">
                            Reserve Wholesale Lot
                          </Link>
                        </MenuItem>
                      )}
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </PageActions>
        <ProductCatalogsDataGrid wholesaleMode={false} />
      </FullPagePaperLayout>
    </>
  );
};
